<template>
  <div>
    <Banner type="small" img="solutions-banner.jpg">
      <h2
        class="banner__title--medium banner__title--separator text--white text--muli text--extrabold mb--x3"
      >
        SOLUTIONS
      </h2>
      <p class="banner__title--text text--white text--normal m--none">
        We offer solutions to solve problems in the processes of Operations,
        Production, Maintenance and Acquisitions that may have in your company.
      </p>
    </Banner>
    <DcSection id="consulting" class="back--grey--c">
      <div class="container">
        <div class="grid grid__1--1 grid--2--12 grid__gap--35 mb--x0--tb">
          <div class="grid__item grid__item--center-v">
            <ImageContent source="solutions/sol_1.jpg" />
          </div>
          <div class="grid__item grid__item--center-v content--rigth--pd">
            <Title
              title="Consulting management services"
              color="2d2d2d"
              position="left"
              twoLines
            />
            <p
              class="solutions__paragraph solutions__paragraph--separator text--grey--c"
            >
              NTS applies the best practice to help organizations better their
              performance, operating primarily through the analysis of existing
              problems and the development of plans for improvement.
            </p>
            <p
              class="solutions__paragraph solutions__paragraph--separator text--grey--c"
            >
              We are able to provide a safe and reliable execution of all
              aspects of the operation and maintenance of large-scale
              facilities, including:
            </p>
            <ul class="">
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Engineering review and construction supervision services
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Project commissioning
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Long term operations and maintenance
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Staffing services
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Technical support services
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Major overhaul of boiler
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </DcSection>
    <CallAction
      backgroundImage="solutions/callexperiences.jpg"
      backgroundColor="#ffffff"
      class="callAction--back--white"
    >
      <h2 class="title__section text--black mb--x3">
        OUR TEAM HAS BEEN ENGINEERING FOR OVER 20 YEARS
      </h2>
      <p class="text--normal text--grey--c text__content--normal ">
        We are formed by professionals from the energy sector, in the gas, oil
        and power generation industries.
      </p>
      <!--<NeButton
        routeLink="/experience"
        align="left"
        color="2d2d2d"
        background="EFDC30"
      >
        what we do for
      </NeButton>-->
    </CallAction>
    <DcSection id="supply" class="back--grey--c">
      <div class="container">
        <div class="grid grid__1--1 grid--2--12 grid__gap--35 mb--x7">
          <div class="grid__item grid__item--center-v">
            <ImageContent source="solutions/sol_2.jpg" />
          </div>
          <div class="grid__item grid__item--center-v content--rigth--pd">
            <Title
              title="Supply and Procurement Services"
              color="2d2d2d"
              position="left"
              :twoLines="true"
            />
            <p
              class="solutions__paragraph solutions__paragraph--separator text--grey--c"
            >
              NTS support the procurement department by revealing the
              information they need to improve their purchasing decisions by
              combining the different aspects of the procurement process into
              one seamless whole that transcends the sum of its parts and
              combining technology and people, so that users can improve their
              own decision making.
            </p>
            <p
              class="solutions__paragraph solutions__paragraph--separator text--grey--c"
            >
              We can supply materials, equipment and spare parts in the
              following fields:
            </p>
            <ul class="mb--x2">
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Instrumentations & Electrical
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Piping and fitting & Valves
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Filter and hydraulic systems
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Seals
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Cathodic protections
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Pumps
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  PV Solar System
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Wellhead system and completion
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Safety equipment
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Integration of process equipment
                </p>
              </li>
            </ul>
            <p
              class="solutions__paragraph solutions__paragraph--separator text--grey--c"
            >
              We represent service and manufacturing enterprises that specialize
              in:
            </p>
            <ul class="">
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Power Generation
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Artificial Lift Equipment and bottom sensor
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Reinforced Thermoplastic Pipes
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Tank no metallic
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Instrumentations and Controls
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Solar System
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Variable Frequency Diver
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Led Flashlight and lamps
                </p>
              </li>
              <li class="list">
                <i class="wz-icon wz-check-double text--black"></i>
                <p id="operations" class="text--grey--c">
                  Explosion proof box
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="grid grid__1--1 grid--2--12 grid__gap--35">
          <div
            class="grid__item grid__item--center-v content--left--pd order--2--tb"
          >
            <Title
              title="Operation and Maintenance Services"
              color="2d2d2d"
              position="right"
              :twoLines="true"
              class="title--left--tb"
            />
            <p
              class="solutions__paragraph solutions__paragraph--separator text--grey--c text--right text--left--tb"
            >
              The O&M business is dedicated to operating and maintaining
              customer facilities related to energy transformation. The O&M team
              will provide the best level of service and operations to preserve
              and maximize the value of the assets.
            </p>
            <p
              class="solutions__paragraph solutions__paragraph--separator text--grey--c text--right text--left--tb"
            >
              O&M services are designed to maximize the lifetime value of your
              assets. NTS proactively monitors and manages your plants
              minimizing downtime and increasing site availability, resulting in
              maximum production, revenues and profitability. Customized service
              packages offer the right fit for any client.
            </p>
            <p
              class="solutions__paragraph solutions__paragraph--separator text--grey--c text--right text--left--tb"
            >
              SERVICE OFFERED
            </p>
            <ul class="">
              <li class="list list--right">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Site or remote Monitoring 24/7/365
                </p>
              </li>
              <li class="list list--right">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Diagnostic and troubleshooting
                </p>
              </li>
              <li class="list list--right">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Analysis of daily plant performance
                </p>
              </li>
              <li class="list list--right list--line-height">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Daily, monthly and annual reports that provide a record of key
                  parameters and significant operational events and trends.
                  Reports include: Executive summary, Daily performance
                  statistics, Annual performance, Maintenance summary Spare
                  parts summary, Summary of technical and other issues, Root
                  cause analysis for corrective maintenance
                </p>
              </li>
              <li class="list list--right">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Preventative Maintenance
                </p>
              </li>
              <li class="list list--right">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Corrective Maintenance
                </p>
              </li>
            </ul>
            <p
              class="solutions__paragraph solutions__paragraph--separator text--grey--c text--right text--left--tb"
            >
              SPECIALITIES
            </p>
            <ul class="">
              <li class="list list--right">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Water Treatment Plant
                </p>
              </li>
              <li class="list list--right">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Electricity Power Generation
                </p>
              </li>
              <li class="list list--right">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Solar Farm
                </p>
              </li>
              <li class="list list--right list--line-height">
                <i class="wz-icon wz-check-double text--black"></i>
                <p class="text--grey--c">
                  Steam Boiler Generation
                </p>
              </li>
            </ul>
          </div>
          <div class="grid__item grid__item--center-v">
            <ImageContent source="solutions/sol_3.jpg" />
          </div>
        </div>
      </div>
    </DcSection>
    <CallAction backgroundImage="call__contact.jpg" backgroundColor="#efdc30">
      <h2 class="title__section text--white mb--x3">
        HAVE A QUESTIONS OR HAVE A SPECIAL REQUEST?
      </h2>
      <p class="text--normal text--white text__content--normal  mb--x3">
        We are ready to help you. In fact, we promise to get back to you in less
        than 12 hours.
      </p>
      <NeButton routeLink="/contact" align="left">
        contact us for a quote
      </NeButton>
    </CallAction>
  </div>
</template>

<script>
import { scroller, setDefaults } from "vue-scrollto/src/scrollTo";

import Banner from "@/components/Banner.vue";
import Title from "@/components/NeTitle.vue";
import ImageContent from "@/components/ImageContent.vue";
import CallAction from "@/components/CallAction.vue";
import NeButton from "@/components/Button.vue";

import DcSection from "@/layouts/DcSection.vue";

export default {
  metaInfo: {
    title: "Solutions",
    meta: [
      {
        name: "description",
        hid: "description",
        content:
          "We offer solutions to solve problems in the processes of Operations, Production, Maintenance and Acquisitions that may have in your company."
      },
      // Open Graph
      { name: "og:title", content: "Solutions | Neuss Technical Services" },
      {
        name: "og:description",
        content:
          "We offer solutions to solve problems in the processes of Operations, Production, Maintenance and Acquisitions that may have in your company."
      },
      { name: "og:type", content: "website" },
      { name: "og:url", content: "https://www.neuss-ts.com/" },
      { name: "og:image", content: "https://davecastworks.com/meta_640.jpg" },
      // Twitter Card
      { name: "twitter:card", content: "summary" },
      { name: "twitter:site", content: "@neussts" },
      {
        name: "twitter:title",
        content: "Solutions | Neuss Technical Services"
      },
      {
        name: "twitter:description",
        content:
          "We offer solutions to solve problems in the processes of Operations, Production, Maintenance and Acquisitions that may have in your company."
      },
      {
        name: "twitter:image",
        content: "https://davecastworks.com/meta_640.jpg"
      },
      { name: "twitter:image:alt", content: "NeussTS Logo" }
    ]
  },
  name: "Solutions",
  components: {
    Banner,
    Title,
    ImageContent,
    DcSection,
    CallAction,
    NeButton
  },
  mounted() {
    if (!this.$route.hash) {
      window.scrollTo(0, 0);
    } else {
      setDefaults({
        container: "body",
        duration: 500,
        easing: "ease",
        offset: -150,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
      });
      const scrollTo = scroller();
      scrollTo(this.$route.hash);
    }
  }
};
</script>

<style scoped>
.solutions__paragraph {
  font-size: 16px;
  line-height: 26px;
}
.solutions__paragraph--separator {
  margin-bottom: 15px;
}

@media screen and (max-width: 768px) {
  .grid__1--1 {
    grid-template: 1fr / 1fr;
  }
  .solutions__paragraph {
    font-size: 18px;
    line-height: 31px;
  }
}
@media screen and (max-width: 595px) {
  .solutions__paragraph {
    font-size: 14px;
    line-height: 27px;
  }
}
</style>
